import React from 'react';
import './App.css';
import Question from './components/question';

function App() {
  return (
    <div className="App">
      <div className="left-side">
        <img style={{ maxWidth: 600 }} src="logo.png" alt="Defined Home Services, LLC" />
      </div>
      <div className="right-side">
        <Question />
      </div>
    </div>
  );
}

export default App;